module.exports = __webpack_public_path__ + "static/media/screen-factory-img.1d2dcd22.png";